/**
 * History state marker for a URL write that must not scroll the page to the top.
 * The 5-minute page writes it when it changes round. ScrollTop skips its reset for that write only.
 * The marker stays on the history entry: a pop or a mount into the entry still scrolls to the top.
 */
export const KEEP_SCROLL_STATE = Object.freeze({ keepScroll: true } as const);

/** True when a history state carries the keep-scroll marker. */
export const keepsScroll = (state: unknown): boolean =>
  typeof state === 'object' && state !== null && (state as { keepScroll?: unknown }).keepScroll === true;
